<script lang="ts">
  export let type: "submit" | "button" = "button";
  export let disabled: boolean = undefined;
  export let secondary: boolean = false;
  export let small: boolean = false;
</script>

<button class="bs3-btn" class:bs3-btn-primary={!secondary} class:bs3-btn-sm={small} class:scom-btn-default={secondary} {type} {disabled} on:click><slot /></button>
